'use client';
import { Atom } from './Atom.js';

const GLOBAL_STORE = new Map();
const atom = (key, initialState)=>{
    if (!GLOBAL_STORE.has(key)) {
        const atom = new Atom(initialState);
        GLOBAL_STORE.set(key, atom);
        return atom;
    }
    return GLOBAL_STORE.get(key);
};

export { atom };
//# sourceMappingURL=store.js.map
